import { enhance } from "@grrr/hansel";

const getArticle = function (url) {
    const request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");

    request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
            const resp = this.response;
            const articles = document.querySelectorAll("article");
            const alreadyAsyncLoadedArticles =
                document.querySelectorAll(".added-article");
            const element = document.createElement("div");
            element.classList.add("added-article");
            element.setAttribute("data-url", url);
            element.setAttribute("data-push-url", url);
            element.innerHTML = resp;
            if (alreadyAsyncLoadedArticles.length > 0) {
                alreadyAsyncLoadedArticles[
                    alreadyAsyncLoadedArticles.length - 1
                ].insertAdjacentElement("afterend", element);
            } else {
                articles[articles.length - 1].insertAdjacentElement(
                    "afterend",
                    element
                );
            }
            enhance(element, window.mmEnhancers);


        }
    };

    request.onerror = function () {};

    request.send();
};

const loaded = [];

export const loadNext = function (el) {
    const url = el.getAttribute("data-url");
    window.addEventListener("scroll", function () {
        const top = el.getBoundingClientRect().top - window.innerHeight;
        if (top < window.innerHeight && !loaded.includes(url)) {
            console.log("loading URL", url);
            loaded.push(url);
            getArticle(url);
        }
    });


};
